"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsTrimmed = IsTrimmed;
const class_validator_1 = require("class-validator");
/**
 * Validates that a string is trimmed (does not start or end with a space).
 */
function IsTrimmed(validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "isTrimmed",
            target: object.constructor,
            propertyName,
            options: validationOptions,
            validator: {
                validate(value) {
                    if (!value) {
                        return true;
                    }
                    return typeof value === "string" && value === value.trim();
                },
                defaultMessage(args) {
                    if (args?.value && typeof args.value !== "string") {
                        return `${propertyName} should be a trimmed string`;
                    }
                    return `${propertyName} can't start or end with a space`;
                },
            },
        });
    };
}
//# sourceMappingURL=IsTrimmed.js.map